export const collectionAccentNames = [
  "marigold",
  "tide",
  "plum",
  "moss",
] as const;

export const collectionLayoutNames = ["feed", "grid"] as const;

export type CollectionAccentName = (typeof collectionAccentNames)[number];

export type CollectionLayoutName = (typeof collectionLayoutNames)[number];

export type SourceKind = "article" | "video" | "x";

export interface CoverCrop {
  offsetX: number;
  offsetY: number;
  zoom: number;
}

export const DEFAULT_COVER_CROP: CoverCrop = {
  offsetX: 0,
  offsetY: 0,
  zoom: 1,
};

export interface CreatorProfile {
  id: string;
  handle: string;
  name: string;
  role: string;
  bio: string;
  website: string;
  location: string;
  avatar?: string;
  ctaLabel?: string;
  ctaUrl?: string;
}

export interface CreatorPost {
  id: string;
  url: string;
  sourceKind: SourceKind;
  sourceLabel: string;
  authorName: string;
  authorHandle: string;
  title: string;
  context: string;
  savedAt: string;
}

export interface CreatorCollectionMembership {
  note: string;
  title: string;
}

export interface CreatorCollection {
  id: string;
  slug: string;
  title: string;
  note: string;
  accent: CollectionAccentName;
  layout: CollectionLayoutName;
  isPublic: boolean;
  updatedAt: string;
  cover: string;
  coverSource: string;
  coverCrop: CoverCrop;
  postIds: string[];
  postMetadata: Record<string, CreatorCollectionMembership>;
}

export interface FeaturedPost {
  collectionId: string;
  postId: string;
}

export interface CreatorPortfolio {
  version: 2;
  profile: CreatorProfile;
  collections: CreatorCollection[];
  posts: CreatorPost[];
  featured?: FeaturedPost[];
}
